import style from './AmountInput.css';
import useTranslation from '../../../localization/i18n.context';
import CurrencyInput from 'react-currency-input-field';

export default function AmountInput({
  className = '',
  currency,
  value,
  onChange,
  onFocus,
  disabled = false,
}) {
  const { getCurrency } = useTranslation();

  return (
    <div className={`${className} ${style.container}`}>
      <CurrencyInput
        className={style.input}
        prefix={`${getCurrency(currency)} `}
        decimalsLimit={2}
        decimalScale={2}
        defaultValue={0.0}
        allowNegativeValue={false}
        decimalSeparator={'.'}
        groupSeparator={','}
        disabled={disabled}
        onValueChange={(value, name, values) => onChange(value)}
        onFocus={state => onFocus()}
        value={value}
        inputMode={'text'}
      />
    </div>
  );
}
